<template>
  <div>
    <b-form-textarea
      v-model="formprompt[mainKey]"
      debounce="50"
      rows="5"
      max-rows="5"
      placeholder="Freely share the current situation with your heartbeat."
      @input="handleQuestionAnswer({key:mainKey, value:formprompt[mainKey]})"
    />
    <div
        v-if="false"
        class="sessions"
        role="tablist"
    >
      <follow-up-card
        v-for="(aFollowUp, idx) in followUpQuestions"
        :followup="aFollowUp"
        :idx="idx"
        :key="`followup_${idx}`"
        @input-answer="handleQuestionAnswer"
      />
    </div>
    <p>May we have a care plan specialist review your plan?</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FollowUpCard from "./followupCard";
export default {
  name: "HeartBeat_BaseInterview",
  components: {
    FollowUpCard
  },
  created() {},
  beforeMount() {},
  mounted() {},
  props: {
    heartbeat: {
      type: Object,
      required: true,
      default: () => {}
    },
    profile: {
      type: Object,
      required: true,
      default: () => {}
    },
    formprompt: {
      type: Object,
      required: false
    },
    maxcp: {
      type: Number,
      required: true,
      default: 0
    },
    info: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({}),
    formPrompt(){
      return this.formprompt ? this.formprompt: null;
    }
  },
  methods: {
    handleQuestionAnswer(kV) {
      this.$emit("input-answer", kV);
    }
  },
  data() {
    return {
      mainKey:'answer_situation',
      followUpQuestions: [
        {key: "answer_symptoms", question: "What symptoms is your heartbeat experiencing?" },
        { key: "answer_issues_aad", question: "Are there issues with agitation, aggression, anxiety, or depression?" },
        { key: "answer_adl", question: "How is the patient's ability to perform daily activities?" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>
